import { CarProps, formatCarLicensePlate, getCarDisplayName } from 'noddi-util';

type Options = {
  car: CarProps & { displayName?: string | null };
  showLicensePlate?: boolean;
};

/**
 * The backend's customer-facing name (make and model family, else registry model). Records and booking drafts
 * without it fall back to the registry name. Never shows the year.
 */
export const getCarName = ({ car, showLicensePlate = false }: Options) => {
  if (!car.displayName) {
    return getCarDisplayName({ car, showLicensePlate, showYear: false });
  }
  const plate = showLicensePlate ? formatCarLicensePlate(car) : '';
  return plate ? `${car.displayName} - ${plate}` : car.displayName;
};
